<template>
  <div class="header-nav-wrapper pt-2 pb-2">
      <div class="container lg:px-0">
        <div class="md:flex items-center">
            <div class="w-full md:w-8/12 lg:w-9/12 pb-4 md:pb-0">
              <router-link class="m-auto" to="/">
                <img class="pl-3 pr-3 md:pl-0 md:pr-0" src="/images/logo.png">
              </router-link>
            </div>
            <div class="w-full md:w-4/12 lg:w-3/12 text-center md:text-left pb-4 md:pb-0 pl-6 md:pl-0">
              <div class="btn-width m-auto md:m-0 md:ml-auto">
                <div class="text-title font-bold text-lg leading-tight text-white pb-2">Call Us</div>
                <a href="tel:+60102721682" class="orange-tel-btn flex justify-center">
                  <img width="22" class="mr-1" src="/images/icon-phone.png">
                  <span class="pl-1">010-272 1682</span>
                </a>
              </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Headernav'
}
</script>

<style>
.header-nav-wrapper {
  background-color: #141414;
}
</style>
